import { render, staticRenderFns } from "./rfqAttachmentList.vue?vue&type=template&id=21411df0&scoped=true"
import script from "./rfqAttachmentList.vue?vue&type=script&lang=js"
export * from "./rfqAttachmentList.vue?vue&type=script&lang=js"
import style0 from "./rfqAttachmentList.vue?vue&type=style&index=0&id=21411df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21411df0",
  null
  
)

export default component.exports